import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, TitleStrategy } from '@angular/router';
import { CareerGradTitleStrategy } from './shared/services/career-grad-title.strategy';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { routes } from './app.routes';
import { authHttpInterceptor } from './shared/interceptors/auth-http.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: CareerGradTitleStrategy },
    provideHttpClient(withFetch(), withInterceptors([authHttpInterceptor])),
    provideClientHydration(
      withEventReplay(),
      // Home payload must be refetched in the browser (SSR URL can differ from the dev proxy).
      withHttpTransferCacheOptions({
        filter: (req) => !req.url.includes('/public/marketing/home'),
      }),
    ),
  ]
};
